import { render, staticRenderFns } from "./CardRequirementComponent.vue?vue&type=template&id=74d3a3d7"
import script from "./CardRequirementComponent.vue?vue&type=script&lang=ts"
export * from "./CardRequirementComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports